import { usePreviewPanelsContext } from '@atlassian/preview-panels-api';

export const usePreviewPanelWidth = () => {
	const context = usePreviewPanelsContext();
	const emptyWidth = { width: undefined };

	if (!context) {
		return emptyWidth;
	}

	const {
		state: { width, panel },
	} = context;

	if (!panel) {
		return emptyWidth;
	}

	return { width };
};
